// Lazy load function
const lazyLoad = (file) => () => import(/* webpackChunkName: "[request]" */ `@/views/production/work-oder/grid-reports/${file}.vue`);

export default [
    {
        path: "/work-order-actual-costs",
        name: "work-order-actual-costs",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "WorkOrder",
        },
        components: {
            content: lazyLoad("work-order-actual-costs"),
        },
    },
];